module.exports = __webpack_public_path__ + "static/media/g-radar.8fa1c0c8.png";